export default __webpack_public_path__ + "static/media/Exclude.836d54ea.svg";